import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Fuse from 'fuse.js'
import { isEmpty } from 'lodash'
import { useLocation } from 'react-router-dom'

import ListFilters from 'components/ModifierGroups/ListFilters'
import ModifierGroupsComponent from 'components/ModifierGroups'
import Layout from 'components/Layout'
import Banner from 'components/Banner'

import { getCurrentVenueUuid } from 'store/Venues/selector'
import { setModifierGroupsSortingMode } from 'store/ModifierGroups/actions'
import { getOrgName } from 'store/AppState/selector'
import { getSearchModifierGroupsValue } from 'store/ModifierGroups/selectors'

import { getModifierGroups } from 'store/ModifierGroups/selectors'

import {
  clearItemsIndexes,
  loadGlobalItems,
} from 'store/Items/actions'
import { fetchFeatureFlags } from 'store/FeatureFlags/actions'
import { loadDisplayCategories } from 'store/DisplayCategories/actions'
import { loadModifierGroups } from 'store/ModifierGroups/actions'
import { FUSE_OPTIONS } from 'utils/fuseSettings'
import { CATEGORY_BANNER_SETTINGS } from 'resources'
import { getBannerIsOpen } from 'store/AppState/selector'

const ModifierGroups = () => {
  const dispatch = useDispatch()
  const venueUuid = useSelector(getCurrentVenueUuid)
  const orgName = useSelector(getOrgName)
  const modifierGroups = useSelector(getModifierGroups)
  const { pathname } = useLocation()

  const searchGlobalModifierValue = useSelector(
    getSearchModifierGroupsValue
  )
  const isBannerOpen = useSelector((state) =>
    getBannerIsOpen(state, pathname.replace('/', ''))
  )

  const filteredModifierGroups = isEmpty(searchGlobalModifierValue)
    ? modifierGroups
    : new Fuse(modifierGroups, FUSE_OPTIONS)
        .search(searchGlobalModifierValue)
        .map((modifierGroup) => modifierGroup.item)

  useEffect(() => {
    dispatch(loadDisplayCategories({ venueUuid: venueUuid }))
    dispatch(loadModifierGroups(venueUuid))
    dispatch(loadGlobalItems(venueUuid))
    dispatch(fetchFeatureFlags(venueUuid, orgName))

    return () => {
      return () => {
        dispatch(clearItemsIndexes())
        dispatch(setModifierGroupsSortingMode(false))
      }
    }
  }, [dispatch, orgName, venueUuid])

  return (
    <Banner bannerSettings={CATEGORY_BANNER_SETTINGS}>
      <Layout
        isSidebar
        navbarContent={<ListFilters />}
        isBannerOpen={isBannerOpen}
        mainContent={
          <ModifierGroupsComponent
            modifierGroups={filteredModifierGroups}
          />
        }
      />
    </Banner>
  )
}

export default ModifierGroups
